import { attributionConstants } from './Attribution.constants';
import moment from 'moment';

const todaysDate = moment().format('YYYY-MM-DD');
const dateFrom = moment().subtract(7, 'd').format('YYYY-MM-DD');
const initialState = {
  models: {},
  dimensions: {},
  selected_date_range: [dateFrom, todaysDate]
};
const attributionReducer = (state = initialState, action) => {
  switch (action.type) {
    case attributionConstants.GET_ATTRIBUTION_MODEL_REQUEST:
      return {
        ...state,
        models: { loading: true, error: false }
      };
    case attributionConstants.GET_ATTRIBUTION_MODEL_SUCCESS:
      return {
        ...state,
        models: { loading: false, error: false, ...action.payload }
      };
    case attributionConstants.GET_ATTRIBUTION_MODEL_FAILED:
      return {
        ...state,
        models: { loading: false, error: true }
      };

    case attributionConstants.GET_ATTRIBUTION_DIMENSION_REQUEST:
      return {
        ...state,
        dimensions: { loading: true, error: false }
      };
    case attributionConstants.GET_ATTRIBUTION_DIMENSION_SUCCESS:
      return {
        ...state,
        dimensions: { loading: false, error: false, ...action.payload }
      };
    case attributionConstants.GET_ATTRIBUTION_DIMENSION_FAILED:
      return {
        ...state,
        dimensions: { loading: false, error: true }
      };

    case attributionConstants.SET_SELECTED_DATERANGE_SUCCESS:
      return {
        ...state,
        selected_date_range: action.payload
      };

    case attributionConstants.GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_REQUEST:
      return {
        ...state,
        channelOverlapTableData: { loading: true, error: false }
      };
    case attributionConstants.GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_SUCCESS:
      return {
        ...state,
        channelOverlapTableData: { loading: false, error: false, ...action.payload }
      };
    case attributionConstants.GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_FAILED:
      return {
        ...state,
        channelOverlapTableData: { loading: false, error: true }
      };

    case attributionConstants.GET_AVAILABLE_TRAFFIC_SOURCES_REQUEST:
      return {
        ...state,
        availableTrafficSources: { loading: true, error: false }
      };
    case attributionConstants.GET_AVAILABLE_TRAFFIC_SOURCES_SUCCESS:
      return {
        ...state,
        availableTrafficSources: { loading: false, error: false, ...action.payload }
      };
    case attributionConstants.GET_AVAILABLE_TRAFFIC_SOURCES_FAILED:
      return {
        ...state,
        availableTrafficSources: { loading: false, error: true }
      };

    case attributionConstants.GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_REQUEST:
      return {
        ...state,
        channelOverlapChartData: { loading: true, error: false }
      };
    case attributionConstants.GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_SUCCESS:
      return {
        ...state,
        channelOverlapChartData: { loading: false, error: false, ...action.payload }
      };
    case attributionConstants.GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_FAILED:
      return {
        ...state,
        channelOverlapChartData: { loading: false, error: true }
      };

    case attributionConstants.GET_ATTRIBUTION_UTMMAPPING_REQUEST:
      return {
        ...state,
        utmMapping: { loading: true, error: false }
      };
    case attributionConstants.GET_ATTRIBUTION_UTMMAPPING_SUCCESS:
      return {
        ...state,
        utmMapping: { loading: false, error: false, ...action.payload }
      };
    case attributionConstants.GET_ATTRIBUTION_UTMMAPPING_FAILED:
      return {
        ...state,
        utmMapping: { loading: false, error: true }
      };

    default:
      return state;
  }
};

export default attributionReducer;
